import React from "react";
import { Conversation } from "../../../types/Entities/Messaging/Conversation";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { DraftsOutlined, EmailOutlined } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { conversationHasUnreadMessage } from "../../../services/messagingService";
import { Stack } from "@mui/material";
import dayjs from "dayjs";

type ConversationProps = {
  conversation: Conversation;
  setOpenConversationId: (conversationId: number) => void;
};

export default function ConversationRow({ conversation, setOpenConversationId }: ConversationProps) {
  const hasUnreadMessage = conversationHasUnreadMessage(conversation);

  const latestMessageCreatedDateDayjs = dayjs(conversation.latestMessageCreatedDate);

  const latestMessageCreatedDateIsToday = latestMessageCreatedDateDayjs.isSame(dayjs(), "day");
  const latestMessageCreatedDateIsThisYear = latestMessageCreatedDateDayjs.isSame(dayjs(), "year");

  let dateStringToDisplay;

  switch (true) {
    case latestMessageCreatedDateIsToday:
      dateStringToDisplay = latestMessageCreatedDateDayjs.format("HH:mm");
      break;
    case latestMessageCreatedDateIsThisYear:
      dateStringToDisplay = latestMessageCreatedDateDayjs.format("DD.MMM");
      break;
    default:
      dateStringToDisplay = latestMessageCreatedDateDayjs.format("DD.MM.YYYY, HH:mm") + " Uhr";
      break;
  }

  return (
    <TableRow hover sx={{ cursor: "pointer" }} onClick={() => conversation.id && setOpenConversationId(conversation.id)}>
      <TableCell sx={{ display: { xs: "none", sm: "table-cell", width: "auto" } }}>
        <Stack sx={{
          justifyContent: "center"
        }}>{hasUnreadMessage ? <EmailOutlined /> : <DraftsOutlined />}</Stack>
      </TableCell>
      <TableCell sx={{ maxWidth: 0, width: "100%" }}>
        <Typography
          noWrap
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          {hasUnreadMessage ? <strong>{conversation.subject}</strong> : conversation.subject}
        </Typography>
        {conversation.latestMessageCreatedDate !== conversation.created && (
          <Typography>Neueste Nachricht: {dayjs(conversation.latestMessageCreatedDate).format("DD.MM.YYYY, HH:mm")} Uhr</Typography>
        )}
      </TableCell>
      <TableCell sx={{ width: "auto" }}>
        <Typography>{dateStringToDisplay}</Typography>
      </TableCell>
    </TableRow>
  );
}
